export default __webpack_public_path__ + "static/media/avatar_merlion4.675bf072.mp3";